﻿import './../libs/jquery-tabs';
import RandomGenerator from './randomGenerator';


class Menu {
  constructor(elm) {
      this.$elm = $(elm);
  }

  choosenTitleInit() {
    var $wrap = $('#choosen__one');
    var $items = $wrap.find('.book__item')
    var itemCount = $items.length;
    var randomGenerator = new RandomGenerator(0, itemCount);

    for (var i = 0; i < $items.length; i++) {
      // console.log(randomGenerator.get());
    }

  }

  showSubMenu() {
    var self = this;

    function showSubMenuProcedure(e) {
      //console.log('procedure xXX');
      var $this = $(this);
      var isMobile = window.matchMedia('(max-width: 767px)').matches;

      // On mobile, prevent default and only open submenu
      if (isMobile && !$this.hasClass('active')) {
        e.preventDefault();
        e.stopPropagation();
      }

      //var $this = thisParam;

      self.$elm.find('.main-nav__item').removeClass('active');
      $this.addClass('active');

      var $renderContent = $this.parent().find('.render-later');


      $renderContent.each(function(){
          var $loader = $(this);
          var url = $loader.data('href');
          var loader_id = $loader.attr('id');
          if (!loader_id) {
              loader_id = "showSumMenuAUtO" + (Menu._showSubMenuIdCounter++).toString();
              $loader.attr('id', loader_id)
          }

          if ($loader.data('render-later-done') || $loader.data('render-later-pending')) return;
              $renderContent.addClass('loading');
              $loader.data('render-later-pending', true);
              setTimeout(function () { $loader.data('render-later-pending', false); }, 120000); // 120s
            Linksoft.Web.LoadByAjax(loader_id, {
              url: url,
              cache: true,
              ":background": true,
              successHandler: function (section) {
                  $loader.data('render-later-done', true);
                  $loader.data('render-later-pending', false);
                  // self.choosenTitleInit()

                  $loader.removeClass('loading');
                  // reinit tabs
                  $('.sub-menu__inner').tabs();

                  // Wrap sub-menu__close with parent title
                  var $subMenu = $this.parent().find('.sub-menu');
                  var $closeBtn = $subMenu.find('.sub-menu__close');
                  if ($closeBtn.length && !$closeBtn.parent().hasClass('sub-menu__close-wrapper')) {
                    var parentTitle = $this.text().trim();
                    $closeBtn.wrap('<div class="sub-menu__close-wrapper"></div>');
                    $closeBtn.before('<span class="sub-menu__parent-title no-desktop">' + parentTitle + '</span>');
                  }
              }
          });
      });
    }
    //self.$elm.on('mouseover', '.main-nav__item.has-submenu', showSubMenuProcedure);
    //self.$elm.on('click', '.main-nav__item.has-submenu', showSubMenuProcedure);
    var mouseoutTimer; // timer to hide after mouse out

    // Only enable mouseleave/mouseenter on desktop (not on mobile @screen-xs-max = 767px)
    var isDesktop = window.matchMedia('(min-width: 768px)').matches;
    if (isDesktop) {
      self.$elm.on('mouseleave', '.main-nav__item.has-submenu,.sub-menu', function (e) {
        //console.log('off');
        mouseoutTimer = setTimeout(function() {
          $(document).click();
          //self.close();
          //console.log('off timer');
        }, 1500); // timeout 1.5 second before it disappears after you leave the popup
      });
      self.$elm.on('mouseenter', '.main-nav__item.has-submenu,.sub-menu', function (e) {
        clearTimeout(mouseoutTimer);
      });
      self.$elm.on('mouseenter', '.main-nav__item.has-submenu', showSubMenuProcedure);
    }

    self.$elm.on('click', '.main-nav__item.has-submenu', showSubMenuProcedure);
  }

  switchingCat() {
    var self = this;
    self.$elm.on('click', '.sub-m-cat__item', function() {
      var $this = $(this);
      $this.parent().find('.sub-m-cat__item').removeClass('active');
      $this.addClass('active')
    });
  }

  mobileSubMenuToggle() {
    var self = this;
    $(document).on('click', '.main-nav__item.has-submenu.no-desktop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var $navItem = $(this);
      var isActive = $navItem.hasClass('active');

      // Close all other submenus
      self.$elm.find('li').removeClass('active');

      if (!isActive) {
        $navItem.addClass('active');
        // Trigger the load for render-later content
        $navItem.trigger('mouseenter');
      }
    });
  }

  close() {
    var self = this;
      // close by click on document

    self.$elm.on('click', '.sub-menu__close', function(){
      $('.main-nav__item').removeClass('active');
    })

    $(document).on('click', function(e) {
      var $target = $(e.target);

      var clickOnTrigger = $target.hasClass('main-nav__item');
      var clickOnContent = $target.closest('.sub-menu').length > 0;

      if ( clickOnContent || clickOnTrigger )
        return;

      $('.main-nav__item').removeClass('active');
    });
  }

  init() {
    Menu._showSubMenuIdCounter = 1;
    this.showSubMenu();
    this.switchingCat();
    this.mobileSubMenuToggle();
    this.close();

    $('.sub-menu__inner').tabs();

    // Mobile sticky header show/hide on scroll (only on cart page)
    if ($('body').hasClass('view-cart') && window.matchMedia('(max-width: 767px)').matches) {
      var lastScrollTop = 0;
      var $header = $('.header__body');
      var scrollThreshold = 5; // minimum scroll distance to trigger

      $(window).on('scroll', function() {
        var scrollTop = $(this).scrollTop();

        if (Math.abs(scrollTop - lastScrollTop) < scrollThreshold) {
          return;
        }

        if (scrollTop > lastScrollTop && scrollTop > 100) {
          // Scrolling down - hide header
          $header.addClass('header--hidden');
        } else {
          // Scrolling up - show header
          $header.removeClass('header--hidden');
        }

        lastScrollTop = scrollTop;
      });
    }

    //
    $(document).on('click', '#mobileSearch, .header__mobile button.icon--search',  function(e) {
      e.preventDefault();
      $('body').removeClass('mobile-filter-on');

      if ($('.header__search').hasClass('active')) {
        $('.header__search, #mobileSearch').removeClass('active');
        $('body').removeClass('overflow-hidden');
      } else {
        $('.header__search, #mobileSearch').addClass('active');
        $('body').addClass('overflow-hidden');

				$('.filter-mobile-btn, .main-nav, #navMobile, .cat-list__wrap').removeClass('active');
      }
    });

    $(document).on('click', '.close-search',  function(e) {
      e.preventDefault();
      $('.header__search, #mobileSearch').removeClass('active');
      $('body').removeClass('overflow-hidden');
    });


    $(document).on('click', '#navMobile',  function(e) {
      e.preventDefault();

      $('body').removeClass('mobile-filter-on');
      var $this = $(this);
      if (!$this.hasClass('active')) {
        $this.addClass('active');
        $('.main-nav').addClass('active');
        $('body').addClass('overflow-hidden');

        // close other
        $('.header__search, #mobileSearch, .filter-mobile-btn, .cat-list__wrap').removeClass('active');
      } else {
        $this.removeClass('active');
        $('.main-nav').removeClass('active');
        $('body').removeClass('overflow-hidden');
      }
    });

    $(document).on('click', '.close-menu',  function(e) {
      e.preventDefault();
      $('.main-nav, #navMobile, #mobileSearch').removeClass('active');
      $('body').removeClass('overflow-hidden');
    });
  }
}

var menu = new Menu('.main-nav');
menu.init();

export default Menu;

